export default __webpack_public_path__ + "static/media/googleTV.6cb33d3c.svg";